import { render, staticRenderFns } from "./accountIndexDataNew.vue?vue&type=template&id=08f9ed24&scoped=true"
import script from "./accountIndexDataNew.vue?vue&type=script&lang=js"
export * from "./accountIndexDataNew.vue?vue&type=script&lang=js"
import style0 from "./accountIndexDataNew.vue?vue&type=style&index=0&id=08f9ed24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f9ed24",
  null
  
)

export default component.exports